import { LineItem } from './../components/adservices/lineitem/lineitem-details.component';
import { map } from 'rxjs/operators';
import { SapiService } from './../services/sapi.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class RedirectGuard implements CanActivate {

	constructor(
		private sapiService: SapiService,
		private router: Router
	) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (next.queryParams?.noRedirect === 'true') {
			return of(true);
		}
		if (next.routeConfig.path === 'lineitems/:id/:tab' && !next.params.id?.includes('new')) {
			return this.sapiService.get('lineitem', next.params.id).pipe(
				map((lineitem: LineItem) => {
					if (lineitem && lineitem.subtype === 'auction' && lineitem.auctionId) {
						this.router.navigate(['/adservices/auction/', lineitem.auctionId]);
						return false;
					} else {
						return true;
					}
				})
			);
		}
		return of(true);
	}
}
